import { gql, QueryHookOptions, QueryResult } from '@apollo/client';

import { useAPIQuery } from 'Api/handler';

import { Request, Company } from 'Types';
import { GET_CLIENTS_FRAGMENT } from '../Fragments/clients';

export type GetRequestDetailResponse = {
  request: Request;
  clients: Company[];
};

type GetRequestDetailVariables = {
  id: number;
};

export const useGetRequestDetail = (
  options?: QueryHookOptions<
    GetRequestDetailResponse,
    GetRequestDetailVariables
  >,
): QueryResult<GetRequestDetailResponse, GetRequestDetailVariables> => {
  return useAPIQuery(GET_REQUEST_DETAIL, options);
};

export const GET_REQUEST_DETAIL = gql`
  query GetRequestDetail($id: Float!) {
    request(id: $id) {
      id
      reference
      floorMeters
      weight
      height
      handlingUnit
      handlingUnitNb
      dangerous
      gerbable
      senderReference
      goodsType
      comment
      transportations
      technicalConstraints
      departureDate
      arrivalDate
      senderName
      originCountry
      originCity
      originZipcode
      originAddress
      originAddress2
      receiverName
      destinationCountry
      destinationCity
      destinationZipcode
      destinationAddress
      destinationAddress2
      email
      sendMail
      company {
        id
        name
      }
      account {
        id
        dieselTaxPercentage
        agency {
          cgv
        }
      }
      user {
        id
        fullName
        role
        isActive
      }
      status {
        id
        value
        label
        statusId
      }
      totalQuotations
      quotations {
        id
        reference
        createdAt
        date
        unitPriceHT
        dieselTaxPercentage
        securityTaxPercentage
        additionalServiceWording
        additionalServiceAmount
        totalAmount
        comment
        hiddenComment
        deadline
        sendMail
        user {
          id
          fullName
        }
        status {
          id
          value
          label
          statusId
        }
        attachments {
          filename
          uuid
        }
      }
      attachments {
        filename
        uuid
      }
    }
    ...Clients
  }
  ${GET_CLIENTS_FRAGMENT}
`;
